<script setup>
import { computed } from "vue"

const apiBase = useApiBase()
const apiUrl = apiBase ? `${apiBase}/api/privacy/` : "/api/privacy/"
const { data } = await useFetch(apiUrl)

const policy = computed(() => data.value?.policy || null)
const breadcrumbs = computed(() => [
  { label: "Головна", to: "/" },
  { label: policy.value?.title || "Політика конфіденційності" },
])
</script>

<template>
  <section v-if="policy" class="section-terms">
    <div class="terms__inner">
      <Breadcrumbs :items="breadcrumbs" />
      <div class="terms__top">
        <div class="terms__top__title">
          <h1 class="terms-title-h1">{{ policy.title }}</h1>
        </div>
        <div class="terms__top__text">
          <div class="text-regular-18 terms__top__text__ph" v-html="policy.intro"></div>
        </div>
      </div>
      <div class="terms__wrapper">
        <div class="text-regular-16 font-montserat" v-html="policy.body"></div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/pages/privacy";

.terms__inner :deep(.breadcrumbs) {
  margin-bottom: 1.25em;
}
</style>
